<script setup>
import { getCurrentInstance } from 'vue'
const { appContext } = getCurrentInstance();

const APP_NAME = appContext.config.globalProperties.APP_NAME;

const currentYear = new Date().getFullYear()
</script>

<template>
    <div class="footer-area text-center mt-25 bg-white border-top-radius">
        <p>
            © {{ currentYear }} <a href="https://hliberty.net/" target="_blank">{{ APP_NAME }}</a>. Todos os direitos reservados.
        </p>
    </div>
</template>


<style lang="scss" scoped>
.footer-area {
    padding: 19.5px 25px;

    span {
        color: #ad63f6;
    }
    a {
        color: var(--primaryColor);
    }
}

@media only screen and (max-width: 767px) {
    .footer-area {
        padding: 15px;
    }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
    .footer-area {
        padding: 20px;
    }
}
</style>
